import { Outlet, useOutletContext } from "react-router-dom";
import { SiteHeader } from "@/components/site/SiteHeader";
import { SiteFooter } from "@/components/site/SiteFooter";
import { useContent } from "@/hooks/useSiteData";
import useReveal from "@/hooks/useReveal";
import usePageTracking from "@/hooks/usePageTracking";

export function useSite() {
  return useOutletContext();
}

export default function SiteLayout() {
  const { data: content, isLoading } = useContent();
  useReveal(!isLoading && !!content);
  usePageTracking();

  if (isLoading || !content) {
    return (
      <div className="pc" style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
        <p style={{ color: "#565a75" }}>Caricamento…</p>
      </div>
    );
  }

  return (
    <div className="pc">
      <SiteHeader />
      <main>
        <Outlet context={content} />
      </main>
      <SiteFooter contacts={content.contacts} desc={content.footer_desc} />
    </div>
  );
}
